'use strict';

class EventsPager {

	/**
	 * Constructor method
	 */
	constructor() {

		// Cache variables for later use
		this.events_parents = document.querySelectorAll('.js-events-parent');

	}

	/**
	 * Init method
	 */
	init() {

		// Bail out early if no events parents found.
		if (!this.events_parents.length) {
			// Trigger the init done event in case some third party is waiting for this to happen.
			document.dispatchEvent(new CustomEvent('eventspager-init-done'));
			return;
		}

		this.events_parents.forEach(eventsParent => {

			// Get pager
			const pager = eventsParent.querySelector('.js-events-pager');
			pager.classList.add('pl-single');
			pager.classList.add('text-base');
			pager.classList.add('mb-double');
			pager.classList.add('md:mb-0');

			// Create label
			const labelText = pager.getAttribute('data-more');
			const label = document.createElement('span');
			label.textContent = labelText + ':';
			label.classList.add('text-black-80');
			label.classList.add('mb-double');
			label.classList.add('md:mb-0');

			// Create item pages
			const pages = [[]];
			const items = eventsParent.querySelectorAll('.js-events-item');
			if (items.length) {
				let page = 0;
				let item_num = 0;
				items.forEach(item => {
					item_num += 1;
					if (item_num > 4) {
						page += 1;
						item_num = 1;
						pages[page] = [];
					}
					pages[page].push(item.id);
				});
				if (pages.length > 1) {
					pager.appendChild(label);

					// Add pager links
					const pagerItems = document.createElement('span');
					pager.appendChild(pagerItems);
					for (let i = 0; i < pages.length; i++) {
						const pagerItem = document.createElement('button');
						pagerItem.classList.add('bg-transparent');
						pagerItem.classList.add('text-black-60');
						pagerItem.classList.add('leading-none');
						pagerItem.classList.add('hocus:underline');
						pagerItem.classList.add('overflow-hidden');
						pagerItem.classList.add('px-6');
						if (i === 0) {
							pagerItem.classList.add('font-bold');
							pagerItem.classList.add('text-black');
							pagerItem.classList.add('underline');
							pagerItem.classList.add('cursor-default');
						} else {
							pagerItem.classList.add('border-l');
							pagerItem.classList.add('border-black-40');
						}
						pagerItem.setAttribute('data-page', i);
						pagerItem.textContent = i + 1;

						// Pager link click event
						pagerItem.addEventListener('click', () => {
							const currentPage = pagerItem.getAttribute('data-page');
							pagerItem.parentNode.querySelectorAll('button').forEach(otherPagerItem => {
								otherPagerItem.classList.remove('font-bold');
								otherPagerItem.classList.remove('text-black');
								otherPagerItem.classList.remove('underline');
								otherPagerItem.classList.remove('cursor-default');
							});
							pagerItem.classList.add('font-bold');
							pagerItem.classList.add('text-black');
							pagerItem.classList.add('underline');
							pagerItem.classList.add('cursor-default');
							items.forEach(item => {
								if (pages[currentPage].indexOf(item.id) === -1) {
									item.classList.add('sm:js-hide');
								} else {
									item.classList.remove('sm:js-hide');
								}
							});
							const scrollPos = (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0);
							const eventsPos = eventsParent.offsetTop;
							if (scrollPos > eventsPos) {
								eventsParent.scrollIntoView({
									behavior: 'smooth'
								});
							}
						});

						// Add pager link to pager
						pagerItems.appendChild(pagerItem);
					}
				}
			}
		});
	}

}
